import { DateAdapter } from '@angular/material/core';

export interface DatepickerOption {
  label: string;
  dateFn: (dateAdapter: DateAdapter<any>) => any;
}
// @dynamic
export class DatepickerOptions {
  static NEVER: DatepickerOption = {
    label: 'Never',
    dateFn: (dateAdapter: DateAdapter<any>) => null
  };

  static TODAY: DatepickerOption = {
    label: 'Today',
    dateFn: (dateAdapter: DateAdapter<any>) => dateAdapter.today()
  };

  static TOMORROW: DatepickerOption = {
    label: 'Tomorrow',
    dateFn: (dateAdapter: DateAdapter<any>) => dateAdapter.addCalendarDays(dateAdapter.today(), 1)
  };

  static IN_ONE_MONTH: DatepickerOption = {
    label: 'In one month',
    dateFn: (dateAdapter: DateAdapter<any>) => dateAdapter.addCalendarMonths(dateAdapter.today(), 1)
  };
}

export class PredefinedDatepickerOptions {
  static ACTIVATION: Array<DatepickerOption> = [
    DatepickerOptions.TODAY,
    DatepickerOptions.TOMORROW,
    DatepickerOptions.IN_ONE_MONTH
  ];

  static EXPIRATION: Array<DatepickerOption> = [
    DatepickerOptions.NEVER,
    DatepickerOptions.TOMORROW,
    DatepickerOptions.IN_ONE_MONTH
  ];
}
